import { E2eeReceiver } from 'features/e2ee/E2eeReceiver';
import { userNameDecrypted } from 'features/e2ee/actions';
import { store } from 'store/store';
import { e2eeDecrypt } from 'features/e2ee/utils/e2eeDecrypt';
import type {
  DecryptionContext,
  DecryptionStrategy,
} from 'features/e2ee/core/decryption-strategies';
import type { EncryptedData } from 'features/e2ee/types';

export class NameDecryption implements DecryptionStrategy {
  canHandle(data: EncryptedData): boolean {
    return !!data.name;
  }

  async decrypt(
    data: EncryptedData,
    receiver: E2eeReceiver,
    context: DecryptionContext
  ): Promise<void> {
    if (!receiver.sharedSecret) {
      throw new Error('Cannot decrypt name. Shared secret is not defined');
    }

    const name = await e2eeDecrypt(data.name!, receiver.sharedSecret);
    receiver.setName(name);

    store.dispatch(
      userNameDecrypted({
        id: receiver.id,
        roomId: receiver.roomId,
        name: receiver.name!,
        rename: context.rename,
      })
    );
  }
}
